import { render, staticRenderFns } from "./Examen.vue?vue&type=template&id=af98741a&scoped=true"
import script from "./Examen.vue?vue&type=script&lang=js"
export * from "./Examen.vue?vue&type=script&lang=js"
import style0 from "./Examen.vue?vue&type=style&index=0&id=af98741a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af98741a",
  null
  
)

export default component.exports